import { Link, Navigate, useParams } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import useSiteMeta from "@/hooks/useSiteMeta";
import { SITE } from "@/site";
import { getCaseStudy } from "@/data/caseStudies";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ui/ScrollToTop";

export default function CaseStudyPage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const study = getCaseStudy(slug);

  const metaOverrides = study
    ? {
        ...study.meta[lang],
        canonical: `${SITE.url}/realizacje/${study.slug}`,
        ogTitle: study.meta[lang].title,
        ogDescription: study.meta[lang].description,
      }
    : {};

  useSiteMeta(lang, metaOverrides);

  if (!study) return <Navigate to="/" replace />;

  return (
    <div className="bg-navy-deep text-white-warm min-h-screen">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 lg:px-20 pt-32 pb-24">
        <Link
          to="/#portfolio"
          className="font-mono text-[10px] tracking-[0.28em] uppercase text-ice/70 hover:text-ice transition-colors"
        >
          ← {lang === "pl" ? "Portfolio" : "Projects"}
        </Link>

        <p className="font-body text-[10px] tracking-[0.28em] uppercase mt-10 text-amber/80">
          {study.tag[lang]}
        </p>
        <h1 className="font-display font-light text-white-warm mt-4 leading-tight" style={{ fontSize: "clamp(2.4rem, 5vw, 3.6rem)" }}>
          {study.title}
        </h1>
        <p className="font-body text-base leading-[1.85] mt-6" style={{ color: "rgba(242,232,216,0.6)" }}>
          {study.excerpt[lang]}
        </p>

        <div className="mt-10 overflow-hidden rounded-xl border border-white/10">
          <img src={study.image} alt={study.title} className="w-full h-auto" loading="lazy" />
        </div>

        <div className="mt-12 space-y-6">
          {study.body[lang].map((paragraph, i) => (
            <p key={i} className="font-body text-base leading-[1.9]" style={{ color: "rgba(242,232,216,0.72)" }}>
              {paragraph}
            </p>
          ))}
        </div>

        <div className="flex flex-wrap gap-2 mt-10">
          {study.tech.map((t) => (
            <span
              key={t}
              className="font-mono text-[10px] tracking-wide px-2.5 py-1 rounded-md border"
              style={{ color: "rgba(200,121,65,0.9)", borderColor: "rgba(200,121,65,0.18)", background: "rgba(200,121,65,0.06)" }}
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          <a href={study.link} target="_blank" rel="noreferrer" className="btn-primary">
            {study.linkLabel} ↗
          </a>
          <Link to="/#kontakt" className="btn-ghost">
            {lang === "pl" ? "Porozmawiajmy o Twoim projekcie" : "Let's talk about your project"}
          </Link>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}